import { HttpContextToken } from '@angular/common/http';

import { ResubmitForm } from '../models/resubmit-form';

export const RESUBMIT_FORM = new HttpContextToken<ResubmitForm>(() => null);
